'use client'

import type { ClientConfig } from '@/config/schema'

import { useClientConfig } from './use-client-env'

/**
 * Hook to access the client configuration from client components.
 * Available during SSR - config doesn't require browser APIs.
 *
 * @example
 * ```typescript
 * import { useConfig } from '@/app/hooks'
 *
 * function MyComponent() {
 *   const config = useConfig()
 *   return <div>Environment: {config.env}</div>
 * }
 * ```
 *
 * @throws Error if used outside ClientEnvProvider
 */
export function useConfig(): ClientConfig {
    return useClientConfig()
}
